export const selectResource = state => state.resource
export const selectShouldRefreshSingleOrder = state => selectResource(state).shouldRefreshSingleOrder
